<template @keyup.enter="checkMblTelno()">
 <LoginBasePopup ref="loginPopupRef" :content-style="loginPopupStyle" v-model="isLoginPopupOpen" custom-class="login" :showCloseButton="true" @login-opend="handleLoginOpend" @login-closed="handleLoginClosed" @close="closeLoginPopup">    <div class="title-area">
    <h2 class="login-title">로그인</h2>
    <div class="logo-area">
      <NuxtLink to="#">
        <img src="@/assets/images/pc/header-logo.png" alt="Hcon 현대이지웰 로고" />
      </NuxtLink>
    </div>
  </div>
  <div class="login-area">
    <div class="form-area">
        <div class="form-box">
          <div class="form-group row">
            <HconInput type="text" ref="usrIdRef" v-model="usrId" label="아이디" :hide-label="true" placeholder="아이디를 입력해 주세요" />
          </div>
          <div class="form-group row">
            <HconInput type="password" ref="usrPasswordRef" v-model="usrPassword" label="비밀번호" :hide-label="true" placeholder="비밀번호를 입력해 주세요" />
          </div>
          <div class="auth-find-box">
            <HconCheckBox :checked="remeberIdChecked =='Y' ? true : false" type="default" label="아이디 저장" :hide-label="false" @change="remeberMeChanged" />
            <ul class="find-list">
              <li>
                <button @:click="closePopup()"><NuxtLink to="/pc/member/login/search-usr-id">아이디 찾기</NuxtLink></button>
              </li>
              <li>
                <button @:click="closePopup()"><NuxtLink to="/pc/member/login/search-usr-password">비밀번호 찾기</NuxtLink></button>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-box col">
          <!-- <button type="button" v-if="useHconConfig().api.baseUrl.indexOf('local') !== -1 || useHconConfig().api.baseUrl.indexOf('dev') !== -1" class="btn md" @:click="login()">(로컬테스트용)로그인</button> -->
          <button type="button" v-if="useHconConfig().api.baseUrl.indexOf('local') !== -1 || useHconConfig().api.baseUrl.indexOf('dev') !== -1" class="btn md" @:click="login('test')">(PASS X)로그인</button>
          <button type="button" class="btn md" @:click="checkMblTelno()">로그인</button>
          <button type="button" class="btn btn-outline md" @:click="join()">회원가입</button>
        </div>
      <p class="description">회원가입 후 Hcon에서 다양한 혜택과 서비스를 만나보세요!</p>
    </div>
    <div class="banner-area">          
      <div class="banner-area">
        <NuxtLink to="">
          <img v-bind:src="bnnrImgPath" :alt="bnnrPhrsCntn" @:click="moveBannerPage()">
        </NuxtLink>
      </div>
    </div>
  </div>
  </LoginBasePopup>
  </template><script setup lang="ts">
  import HconInput from '@/components/com/HconComPCInputField.vue'
  import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
  import LoginBasePopup from "@/components/com/HconComPCPopupBase.vue";
  import { usePopup } from '@/composables/hconUsePopup'
  import { computed, onMounted, onUnmounted } from "vue";
  import { COMMON_CODE, MEMBER_CODE } from '@/constants/hconMessageConstants'
  import type { LoginBannerDto } from '@/types/login/backend-dto-types'
  import {MemberLoginUtils} from "~/utils/login/member-utils";
  import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';


  // 메인 페이지인 경우만 true
  const route = useRoute();
  const inputEncCi = ref("");
  const inputMblTelno = ref("");
  const inputSelfCrtfGndrNval = ref("");
  const inputChrgrNm = ref("");
  const inputBirth = ref("");
  // 전역 팝업
  const {
    isLoginPopupOpen,
    closeLoginPopup,
    openLoginPopupReqAuth,
    openLoginPopup,
    isLoggedIn,
    showAlert,
    isTimeOut,
    isBefore3Min,
    showConfirm
  } = usePopup()
  
  const usrId           = ref("")
  const usrIdRef        = ref<InstanceType<typeof HconInput> | null>(null)
  const usrPassword     = ref("")
  const usrPasswordRef  = ref<InstanceType<typeof HconInput> | null>(null)
  const authInfo  = ref<AuthInfo | null>(null)
  
  const remeberIdCheckBox = ref(false)
  const remeberIdChecked = ref("");
  
  const fetchBuilder        = useHconFetchBuilder();
  const bnnrImgPath = ref("")
  const bnnrShctUrl = ref("")
  const bnnrPhrsCntn = ref("")
  
  const savedId = useCookie<string | null>('memId', {
    maxAge: 60 * 60 * 24 * 7, // 7일
    secure: true,
    sameSite: "lax"
  });
  
  const closePopup = () => {
    isLoginPopupOpen.value = false;
  }
  
  onMounted(async () => {
    const res = await fetchBuilder
    .get<AjaxResult<LoginBannerDto>>('/api/v1/product/display/get-banner-image/1004')
    .build()
    .executeToRaw()
    const resBody = res._data as any;

    bnnrImgPath.value = cu.getFileFullUrl(resBody?.data?.bnnrImgPath, true)
    bnnrShctUrl.value = resBody?.data?.bnnrShctUrl
    bnnrPhrsCntn.value = resBody?.data?.bnnrPhrsCntn
  })
  
  watch(isLoginPopupOpen , (newV, oldV) => {
  if(newV) {
    window.addEventListener('keydown', handleKeydown);
    //2026.01.19 
      
    if(localStorage.getItem("common.auth.rememberId")) {
      const remembermeInfo = localStorage.getItem("common.auth.rememberId")
      if(remembermeInfo) {
        remeberIdChecked.value = "Y";
        const parsedRemembermeInfo = JSON.parse(remembermeInfo);
        usrId.value = parsedRemembermeInfo.hcUsrId;
      }
    }
    
    usrIdRef.value?.onInputTextFocus();
  } else {
    window.removeEventListener('keydown', handleKeydown);
    usrId.value = ''
    usrPassword.value = ''
  }
})

watch(isTimeOut, (newV, oldV) => {
  if(newV) {
    handleAutoLogoutInfoPopup();
  }
})

watch(isBefore3Min, (newV, oldV) => {
  if(newV) {
    handleLoginExtendInfoPopup();
  }
})

// 로그인 팝업 높이값 계산
const loginPopupRef = ref<any>(null)
const contentHeight = ref<string>('auto')

const loginPopupStyle = computed(() => ({
  height: contentHeight.value
}))

const handleLoginOpend = () => {
  const targetElement = loginPopupRef.value?.contentRef

  if (targetElement) {
    const height = targetElement.offsetHeight
    contentHeight.value = height > 0 ? `${height}px` : 'auto'
  }
}

const handleLoginClosed = () => {
  contentHeight.value = 'auto'
}

  const handleKeydown = (e: KeyboardEvent) => {
    if(e.key === 'Enter') checkMblTelno()
  }
  const remeberMeChanged = (isChecked : boolean) => { remeberIdChecked.value= isChecked ? 'Y' :'N' }
  
  const login = async (code : string) => {
    if(remeberIdChecked.value == "Y") {
            localStorage.setItem('common.auth.rememberId', 
              JSON.stringify({
                hcUsrId: usrId.value
              })
            )
        } else if (remeberIdChecked.value == "N") {
          localStorage.removeItem('common.auth.rememberId');
        }


    //아이디 입력
    if(HconCommonUtils.isEmpty(usrId.value)) {
      alert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "아이디", "입력"));
      usrIdRef.value?.onInputTextFocus();
      return false;
    }
  
    //비밀번호 입력
    if(HconCommonUtils.isEmpty(usrPassword.value)) {
      alert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호", "입력"));
      usrPasswordRef.value?.onInputTextFocus();
      return false;
    }
    const encryptPassword = await MemberLoginUtils.encryptPassword(usrPassword.value)
    const memberLoginApi = useHconFetchBuilder()
        .post<AjaxResult<AuthInfo>>('/api/v1/member/auth/login')
        .body({
          id : usrId.value,
          password : encryptPassword,
          systemType : "HCON_FO",
          rememberMe : remeberIdChecked.value,
          usrEncCi :  code=='test'?"test":inputEncCi.value,
          hcUsrMblTelno: inputMblTelno.value,
          selfCrtfGndrNval : inputSelfCrtfGndrNval.value,
          userNm : inputChrgrNm.value,
          usrBirth : inputBirth.value
        })
        .progressMessage('로그인 처리 중입니다.')
        .build();
        
    const res = await memberLoginApi.executeToRaw();
    if (res.status == 200) {
      const resBody = res._data as any;
      if (resBody.resultCode == '200') {
        isLoggedIn.value = true
        useHconAuthInfo().setFromFetch(res);   
        localStorage.setItem('common.auth.isRememberMe','Y')
      } else {
        showAlert({message : resBody.resultMessage})
        return false;
      }

      await showAlert({
          message :  HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "로그인"),
          onConfirm: () => {  
          }
      });

      usrId.value = ""
      usrPassword.value = ""
      remeberIdCheckBox.value = false
      window.removeEventListener('keydown', handleKeydown);

      const goUrl = sessionStorage.getItem('common.auth.redirect')??'';


      if(goUrl != '') {
        useRouter().replace(goUrl);
        // navigateTo({path: goUrl}, {external: false});
      }
      
      setTimeout(() => {
        window.location.reload();
      }, 100);

      sessionStorage.removeItem('common.auth.redirect');
      closeLoginPopup();
    }

  
  }
  //TODO
  //관리자승인이 필요한 계정
  //현재 사용이 제한된 계정
  const join = () => {
    navigateTo({path: '/pc/member/join'}, {replace: false});
    closeLoginPopup();
  }
  
  const moveBannerPage = async () => {
    const res = await fetchBuilder
    .post<AjaxResult<any>>('api/v1/product/display/update-banner-click-count/1004')
    .build()
    .executeToRaw()
    const resBody = res._data as any;
    if(resBody.resultCode == '200') {
      window.location.href = bnnrShctUrl.value;
      closeLoginPopup();
    }
  }

const { $stopTimer } = useNuxtApp()
const handleLoginExtendInfoPopup = async () => {

const result = await showConfirm({
    title: '로그인 연장 안내',
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9023),
    confirmText: '연장하기',
    cancelText: '취소'
  })
  if(result) { 
    const rememberMeToken = localStorage.getItem('common.auth.isRememberMe') == 'N' ? null : SessionStorageSynchronizer.getItem('common.auth.rememberMe');
    if (rememberMeToken != null) {
        try {
            const res = await useHconFetchBuilder().post<AjaxResult<AuthInfo>>('/api/v1/member/auth/auto-login')
                        .headers({'X-Remember-Me':SessionStorageSynchronizer.getItem('common.auth.rememberMe')})
                        .body({
                        })
                        .progressMessage('로그인 처리 중입니다.')
                        .build()
                        .executeToRaw()

                        const resBody = res._data as any;
                        if (resBody.status == 200) {
                          useHconAuthInfo().setFromFetch(result);
                        };
            return;
        } catch (error) {
            console.error('auto-login fail', error);
        }
    }

  }                   
}

const handleAutoLogoutInfoPopup = async () => {
  isLoggedIn.value = false;
  navigateTo({path: '/'}, {external: false});
  const result = await showConfirm({
    title: '자동 로그아웃 안내',
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9024),
    confirmText: '로그인 하기',
    cancelText: '취소'
  })

  if(result) { 
    openLoginPopup();
  } else  {
    showAlert({
      message :  HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "로그아웃이"),
    })
    closeLoginPopup();
  }
}

const checkMblTelno = async () => {
    //아이디 입력
    if(HconCommonUtils.isEmpty(usrId.value)) {
      alert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "아이디", "입력"));
      usrIdRef.value?.onInputTextFocus();
      return false;
    }
  
    //비밀번호 입력
    if(HconCommonUtils.isEmpty(usrPassword.value)) {
      alert(HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, "비밀번호", "입력"));
      usrPasswordRef.value?.onInputTextFocus();
      return false;
    }

    if(remeberIdChecked.value == "Y") {
        localStorage.setItem('common.auth.rememberId', 
          JSON.stringify({
            hcUsrId: usrId.value
          })
        )
    } else if (remeberIdChecked.value == "N") {
      localStorage.removeItem('common.auth.rememberId');
    }
  const encryptPassword = await MemberLoginUtils.encryptPassword(usrPassword.value)

    const resChk = await fetchBuilder
    .post<AjaxResult<any>>("/api/v1/member/auth/login-check")
    .body({
      id : usrId.value,
      password : encryptPassword,
    })
    .build()
    .executeToRaw();
    const resBody = resChk._data as any;
    if (resChk.status == 200) {
      if (resBody.resultCode == '200') {

        const resUrl = await fetchBuilder
            .get<AjaxResult<any>>("/api/v1/certificate/get-certificate-url")
            .query()
            .build()
            .executeToRaw();
            const resBody2 = resUrl._data as any;
        if (resUrl.status == 200) {
          if (resBody2.resultCode == '200') {
            sessionStorage.setItem('common.auth.transaction_id', resBody2.data.transaction_id)
            const popup = window.open(resBody2.data.auth_url,'','width=600, height=1110, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
            window.addEventListener("message", async (event) => {
              if(event.data.returnCode == "0000") {
                inputEncCi.value = event.data.authResultData.ci
                inputMblTelno.value = event.data.authResultData.mobile_no
                inputSelfCrtfGndrNval.value = event.data.authResultData.gender
                inputChrgrNm.value = event.data.authResultData.name
                inputBirth.value = event.data.authResultData.birthdate
                login('');
              } else {
                showAlert({
                message : MEMBER_CODE.ALT_HCON_9034
                });
                
                return false;
              }
          })
        }
          }else {
        showAlert({
        message : resBody2.resultMessage
        });

        return false;
      };
    }else {
      if (resBody.resultCode == '29167') { 

        const result = await showConfirm({
          title: '로그인 실패 안내',
          message: resBody.resultMessage,
          confirmText: '이동하기',
          cancelText: '취소'
        })

        if(result) {
          useRouter().replace('/pc/member/login/search-usr-password');
          closeLoginPopup();
        } else {
          return false;
        }
        
      } else {
        showAlert({
        message : resBody.resultMessage
        });
      }
    return false;
  };
  } else {
    showAlert({
    message : resBody.resultMessage
    });

    return false;
  };
  
};

  </script>
  
  
  <style lang="scss" scoped>
  </style>